import { MenuItem, MenuItems } from "../../@types";
import TagsModal from "../TagsModal";
import { useAddTags, useDeleteTags, useGetUserTags } from "../hooks";
import { checkForNoChangeOnSave, noTagChangeNotification } from "../utils";

type TagsEditSingleProps = {
  hash: string;
  show: boolean;
  onSubmitCallback?: () => void;
  handleShow: () => boolean;
};

const TagsEditSingle = ({
  hash,
  show,
  onSubmitCallback,
  handleShow
}: TagsEditSingleProps) => {
  const { mutate: addTags } = useAddTags();
  const { mutate: deleteTags } = useDeleteTags();
  const { data: initialTags } = useGetUserTags(hash);

  const onFormSubmit = (selectedTags: MenuItems) => {
    if (checkForNoChangeOnSave({ selectedTags, initialTags })) {
      noTagChangeNotification();
    } else {
      const deletedTags = initialTags
        .filter(
          (initialTag: string) =>
            !selectedTags.some(
              (selectedTag: MenuItem) => selectedTag.value === initialTag
            )
        )
        .map((item: string) => ({
          tag: item
        }));

      if (deletedTags?.length) {
        deleteTags({ hash, deletedTags }).finally(() => {
          onSubmitCallback?.();
        });
      }

      const addedTags = selectedTags
        .filter(
          selectedTag =>
            !initialTags.some(
              (initialTag: string) => initialTag === selectedTag.value
            )
        )
        .map((item: MenuItem) => ({
          tag: item.value
        }));

      if (addedTags?.length) {
        addTags({ hash, addedTags }).finally(() => {
          onSubmitCallback?.();
        });
      }
    }
  };

  return (
    <TagsModal
      show={show}
      handleShow={handleShow}
      onFormSubmit={onFormSubmit}
      initialTags={initialTags}
    />
  );
};

export default TagsEditSingle;
